import React, { FC } from "react";
import injectSheet from "react-jss";
import styleSheet from "./styles";
import classNames from "classnames";

interface Props {
  level: string;
  classes?: any;
}

const InterestBars: FC<Props> = props => {
  const levelMap = {
    low: 1,
    medium: 2,
    high: 3
  };

  const levelNumber = levelMap[props.level];

  return (
    <div className={props.classes.container}>
      <div
        className={classNames(props.classes.bar, {
          [props.classes.highlighted]: levelNumber > 0
        })}
      ></div>
      <div
        className={classNames(props.classes.bar, {
          [props.classes.highlighted]: levelNumber > 1
        })}
      ></div>
      <div
        className={classNames(props.classes.bar, {
          [props.classes.highlighted]: levelNumber > 2
        })}
      ></div>
    </div>
  );
};

export default injectSheet(styleSheet)(InterestBars);
